export enum PlatformOnboardingPath {
  KNOWN = 'known',
  UNKNOWN = 'unknown',
}
